<template>
  <div class="page-nil"></div>
</template>
<script>
export default {
  created() {
    location.href = `${location.href}en/WarrantySearch`
    setTimeout(() => {
      location.reload()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/nil/index.vue